export default __webpack_public_path__ + "assets/8b90fe7b942c6f389f1ddd01103d3b0e.jpg";